import Show from './Show';
export default Show;
